import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, ThemeProvider } from '@fluentui/react';
import ReactDOM from 'react-dom';

import { theme } from '../utils/theme';

type PopupConfig = {
  title?: string;
  message?: string;
  buttonText?: string;
};

type PopupResponse = {
  cancelled: boolean;
};

export const popup = (config: string | PopupConfig): Promise<PopupResponse> =>
  new Promise((resolve) => {
    if (typeof config === "string") {
      config = { message: config } as PopupConfig;
    }

    const div = document.createElement("div");

    const unmount = () => {
      ReactDOM.unmountComponentAtNode(div);
      div.remove();
    };
    const cancelPopup = () => {
      unmount();
      resolve({ cancelled: true });
    };
    const submitPopup = () => {
      unmount();
      resolve({ cancelled: false });
    };

    const element = (
      <ThemeProvider theme={theme}>
        <Dialog
          hidden={false}
          onDismiss={cancelPopup}
          dialogContentProps={{
            type: DialogType.largeHeader,
            title: config.title || "Sistem",
            subText: config.message,
          }}
        >
          <DialogFooter>
            <DefaultButton
              onClick={cancelPopup}
              text={config.buttonText ? "İptal" : "Tamam"}
            />
            {config.buttonText && (
              <PrimaryButton onClick={submitPopup} text={config.buttonText} />
            )}
          </DialogFooter>
        </Dialog>
      </ThemeProvider>
    );

    document.body.append(div);
    ReactDOM.render(element, div);
  });
